import 'bootstrap-css-only/css/bootstrap.min.css'; 
import "@fortawesome/fontawesome-free/css/all.min.css";
import 'mdbreact/dist/css/mdb.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { CookiesProvider } from 'react-cookie';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import unregister from './registerServiceWorker';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

ReactDOM.render(  
    <CookiesProvider>
      <BrowserRouter basename={baseUrl}>
          <App />
      </BrowserRouter>
    </CookiesProvider>
,
  rootElement);


// If you want your app to work offline and load faster, you can change
// unregister() to registerServiceWorker() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
unregister();